angular.module('homebot.directives')

.directive('pmiEstimateAdjuster', [function(){
  return {
    restrict: 'A',
    controllerAs: 'pmiEstimateCtrl',
    bindToController: {
      estimate: '=',
      confirmEstimate: '&',
      setPmi: '=',
      showLoading: '='
    },
    scope: {},
    templateUrl: '/homes/templates/partials/pmi-estimate-adjuster.html',
    controller: function(){
      const ctrl = this;

      ctrl.pmiInput = null;
      ctrl.confirmLoading = false;

      ctrl.manualLoading = function () {
        return !ctrl.confirmLoading && ctrl.showLoading;
      }

      ctrl.confirmEstimate = function () {
        ctrl.confirmLoading = true;
        ctrl.setPmi(ctrl.estimate);
      }
    }
  }
}]);
